import { Component, Vue, Model, Prop } from 'vue-property-decorator';
import { Task } from '@/models/Task';
import Thumbnail from '@/components/Thumbnail/Thumbnail.vue';

@Component<TaskList>({
  components: {
    Thumbnail,
  },
})
export default class TaskList extends Vue {
  @Model('tasks', { default: () => new Task() })
  protected tasks!: Task[];

  @Prop()
  protected canEdit!: boolean;

  @Prop()
  protected totalPrice!: number;

  protected selectedTask: Task | null = null;

  protected isLoading = false;

  protected isEditingTask = false;

  protected editTask(task: Task): void {
    this.selectedTask = task;
    this.isEditingTask = true;
  }

  protected getSubTotalForDamage(task: Task): number {
    if (task.sub_tasks) {
      let total = 0;

      for (let i = 0; i < task.sub_tasks.length; i += 1) {
        // @ts-ignore
        total += task.sub_tasks[i].prices?.total_incl_vat;
      }

      return total;
    }

    return 0;
  }

  protected async toggleComplete(task: Task): Promise<void> {
    let status = '';

    if (task && task.sub_tasks && task.sub_tasks.length > 0) {
      if (task.status_raw === 'done') {
        status = 'todo';
      } else {
        status = 'done';
      }

      const subtasks = task.sub_tasks.map(async (subtask) => await new Task(subtask).updateStatus(status));
      await Promise.all(subtasks);
      this.$emit('taskUpdated');
      return;
    }

    if (task.status_raw === 'done') {
      status = 'todo';
    } else {
      status = 'done';
    }

    await new Task(task).updateStatus(status);
    this.$emit('taskUpdated');
  }

  // protected get totalPrice(): number {
  //   if (this.tasks) {
  //     let total = 0;

  //     for (let i = 0; i < this.tasks.length; i += 1) {
  //       total += this.getSubTotalForDamage(this.tasks[i]);
  //     }

  //     return total;
  //   }

  //   return 0;
  // }
}
